export default {
    "msg": {
        "8": "8",
        "20": "20",
        "250": "250",
        "Enter a new password": "Введите новый пароль",
        "Empty": "空",
        "No data": "Нет данных",
        "Installation Package List": "Список установочных пакетов",
        "Update Package": "пакет обновления",

        "Settings - Profiles": "Настройки - Профили",
        "User Management": "Управление пользователями",
        "Operation Records": "Записи об операциях",
        "Exit": "Выход",
        "Total pages:": "Всего страниц: ",
        "page": "страница",
        "Go to": "Перейти к",
        "Prev": "Назад",
        "Next": "Далее",
        "per page": " ",
        "items": " ",
        "Please enter the page number to go to": "Введите количество страниц",
        "Language": "Язык",
        "Profile Picture": "Фотография профиля",
        "Old Password": "Старый пароль",
        "New Password": "Новый пароль",
        "Confirm Password": "Подтвердить пароль",
        "The two passwords entered do not match": "Два введенных пароля не совпадают",
        "Enter the new password again": "Введите новый пароль еще раз.",
        "This must match the new password above": "Он должен совпадать с новым паролем выше.",
        "Invalid input。Password length must be 8–16 characters": "Недопустимый ввод. Пароль должен содержать от 8 до 16 символов",
        "Lenovo Privacy Statement": "Лицензионное соглашение на программное обеспечение Lenovo",
        "Lenovo Software License Agreement": "Лицензионное соглашение на ПО Lenovo",
        "Third-Party Notice": "Уведомление третьих сторон",
        "Third-party notifications":"Сторонние уведомления",
        "Change Password": "Изменить пароль",
        "Edit Profile": "Редактировать профиль",
        "Exited successfully": "Выход выполнен успешно",
        "Admin": "Администратор",
        "Common user": "Обычный пользователь",
        "Super Admin":"Суперадминистратор",
        "Model": "Модель",
        "Are you sure you want to delete this?": "Действительно удалить?",
        "Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters": "Введите новый пароль.Он должен содержать по крайней мере три из следующих элементов: прописные буквы, строчные буквы, цифры и специальные символы.",
        "It must include at least three of the following: uppercase letters, lowercase letters, numbers, and special characters": "Он должен содержать по крайней мере три из следующих элементов: прописные буквы, строчные буквы, цифры и специальные символы.",
        "Tip": "Совет",
        "Confirm": "Подтвердить",
        "Cancel": "Отмена",
        "Deletion successful": "Удаление выполнено успешно",
        "Password changed successfully": "Пароль успешно изменен",
        "The file to upload is larger than 100 MB。 Please select another one。": "Размер загружаемого файла превышает 100 МБ. Выберите другой файл.",
        "Your session has expired。 Please log in again。": "Текущий статус входа истек, пожалуйста, войдите снова!",
        "Invalid network request URL": "Неправильный адрес сетевого запроса!",
        "Unknown server error": "На сервере произошла неизвестная ошибка!",
        "An unknown error has occurred": "Произошла неизвестная ошибка!",
        "Request timeout。 Please check your network and try again。": "Время ожидания запроса истекло. Проверьте сетевое подключение и повторите попытку.",
        "Failed to connect to server": "Не удалось подключиться к серверу",
        "Your network may be currently disconnected": "Возможно, сеть сейчас отключена",
        "No related device found": "Не найдено соответствующее оборудование",
        "Pre-upgrade component not found in the device": "Обновленные компоненты в устройстве не найдены",
        "FWID of the installation component not found": "Установка компонентов FWID не найдена",
        "Failed to set upgrade information": "Ошибка обновления информации",
        "Failed to set specified update options": "Ошибка указания параметров обновления",
        "Failed to install the update package": "Ошибка установки пакета обновления",
        "Failed to obtain the device handle": "Ошибка получения ключа устройства",
        "Upgrade device mismatch": "Обновление устройств не совпадает",
        "Installation failed: Pre-upgrade component not found in the device": "Невозможно установить: в устройстве не найден компонент предварительного обновления",
        "Installation failed: FWID mismatch in the component list": "Невозможно установить: FWID не соответствует компоненту",
        "Installation failed: No matching monitor found for upgrade": "Невозможно установить: монитор не найден для обновления",
        "The monitor does not exist": "Монитор не существует",
        "The command has been sent": "Команда отправлена",
        "The group does not exist": "Группа не существует",
        "The command does not exist": "Команда не существует",
        "Setting does not exist": "Настройка не существует",
        "The settings profile does not exist": "Профиль параметров не существует",
        "The update package does not exist": "Пакет обновления не существует",
        "The update package record does not exist": "Запись пакета обновления не существует",
        "Invalid password format。 It must be between 8 and 30 characters long。": "Недопустимый формат пароля. Его длина должна составлять от 8 до 30 символов.",
        "Password format is incorrect, password must include at least three types of the following: uppercase letters, lowercase letters, digits, and special characters": "密码格式不正确，密码至少包含大写字母、小写字母、数字和特殊字符中的三种类型",
        "The field is empty": "Поле пусто",
        "Update time cannot be null": "升级时间不能为空",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。": "Недопустимое время обновления. Оно не может быть ранее текущего времени или более чем на 30 дней в будущем.",
        "Uploaded file is null": "上传文件为空",
        "Uploaded file format is incorrect， file format can only be zip/exe/dmg/app": "上传文件格式不正确,文件格式只能为zip/exe/dmg/app",
        "Uploaded file format is incorrect， file cannot have no extension": "上传文件格式不正确,文件不能没有后缀",
        "Login failed。 Make sure you entered the correct account ID and password。": "Ошибка входа. Убедитесь, что вы ввели правильный идентификатор учетной записи и пароль.",
        "Date": "Дата",
        "Time": "Время",
        "This action will permanently delete the current data. Do you want to continue?": "Эта операция навсегда удалит текущие данные, будет ли она продолжена?",
        "Please select an item to delete first": "Выберите пункт и удалите его.",
        "Select an item and then delete":"Выберите элемент и удалите его",
        "Begin Download": "Начать загрузку",
        "Start Download":"Начать загрузку",
        "Password incorrect": "Неверный пароль",
        "Password Changed Successfully": "Изменить пароль успешно",
        "Display ID or Group ID is empty": "Идентификатор монитора или идентификатор группы пусты",
        "Select the update package": "Выберите пакет обновления",
        "Username already exists": "Имя пользователя уже существует",
        "Executing monitor setting command。Please wait 10s before making new changes。": "Команда настройки дисплея выполняется, подождите 10s, прежде чем делать новые настройки",
        "Close": "Выкл",
        "Role does not exist。 Cannot modify role。": "Роль не существует, роль не может быть изменена",
        "Unknown Command": "Неизвестная команда",
        "Access Token Expired": "Визит истек.",
        "Invalid Refresh Token": "Неверный значок обновления",
        "Missing Request Parameters:": "Отсутствуют параметры запроса:",
        "Incorrect Request Parameter Type:": "Ошибка типа параметра запроса:",
        "Request URL Not Found:": "Адрес запроса не существует:",
        "Incorrect Request Method:": "Неправильный способ запроса:",
        "Log In": "Войти",
        "account ID": "Номер счета",
        "password": "Пароль",
        "Update failed": "Ошибка обновления",
        "Reset Password?": "Сбросить пароль",
        "Logged in successfully": "Вход выполнен успешно",
        "Please contact the system administrator to reset your password": "Обратитесь к системному администратору для сброса пароля.",
        "Retry limit exceeded。 Please try again after 30 minutes": "重试超过5次，请30分钟后再试",
        "Enter the model / host name / firmware version number": "Введите модель / название хоста / номер версии прошивки",
        "New Group": "Новая группа",
        "Delete Group": "Удалить группу",
        "Display Columns": "Показать столбцы",
        "Collapse": "Свернуть",
        "Expand": "Развернуть",
        "Move To": "Переместить в",
        "Export": "Экспорт",
        "Power On": "Включить питание",
        "Power Off": "Выключить питание",
        "Screen lock": "屏幕锁定",
        "Unlock screen": "屏幕解锁",
        "Settings": "Настройки",
        "Export Settings Profiles": "Экспорт профилей настроек",
        "Update": "Обновление",
        "Delete Monitor": "Удалить монитор",
        "Total devices": "Всего устройств",
        "Selected devices": "Выбрано устройств",
        "Update package name": "Имя пакета обновления",
        "Update Time": "Время обновления",
        "Apply to all displays of the same model": "Применяется к мониторам того же типа",
        "Display Settings": "Настройки дисплея",
        "Select All": "Выбрать все",
        "Settings Profiles": "Профиль настроек",
        "Filename": "Имя файла",
        "Group": "Группа",
        "Monitor Model": "Модель монитора",
        "Special ID": "Специальный идентификатор",
        "Host Name": "Имя хоста",
        "Host Status": "Статус хоста",
        "Monitor Status": "Статус монитора",
        "Lock Status": "Состояние блокировки",
        "Update Progress": "Ход обновления",
        "Settings Profile": "Профиль настроек",
        "Tips": "Советы",
        "Active Time": "Время использования",
        "Overclock": "Превышение частоты",
        "Operation successful": "Операция прошла успешно",
        "Please save data": "Сохраните данные",
        "Select the data first": "Сначала выберите данные",
        "Cannot modify when ungrouped": "Изменение невозможно, если элементы не сгруппированы",
        "Deselect All": "Снять выделение",
        "Select the GAMMA node label value": "Выберите значение метки узла GAMMA",
        "Ungrouped": "Несгруппированные",
        "Offline": "Не в сети",
        "Online": "В сети",
        "Power on": "Включай.",
        "Power off": "Выключить",
        "Locked": "Заблокировано",
        "Open": "Не заблокирован",
        "Open": "Не заблокировано",
        "Unlocked":"Не заблокировано",
        "Not connected": "Не подключен",
        "Connected": "Подключение",
        "Set the update start time": "Задайте время начала обновления",
        "Now": "Сейчас",
        "Set upgrade mode": "Настройка режима обновления",
        "Interactive Mode": "Интерактивный режим",
        "Silent mode": "Бесшумный режим",
        "In this mode， a monitor firmware update screen appears and requests confirmation to proceed。Users may choose to postpone the update twice，after which the update is mandatory。": "В этом режиме появится экран обновления прошивки монитора и запросит у пользователей подтверждение продолжения. Пользователи могут отложить обновление дважды, после чего обновление будет выполнено автоматически.",
        "In this mode， when the monitor is online， the firmware update will be automatically performed in the background。 Users will not see any notifications。 The update will take effect when the display is restarted。 The restart of the monitor takes about a few seconds， and won’t affect any ongoing tasks on your computer。": "In this mode, when the monitor is online, the firmware update will be automatically performed in the background. Users will not see any notifications. The update will take effect when the display is restarted. The restart of the monitor takes about a few seconds, and won't affect any ongoing tasks on your computer.",
        "Invalid input": "Недопустимый ввод",
        "Failed to log in": "Не удалось войти",
        "Select your preferred restart time。": "Выберите предпочтительное время перезапуска в зависимости от использования.",
        "You have still selected the group that the device currently belongs to。 If you want to move the device， please select another group。": "您点击的仍是设备现属组，若要移动，请选其他组。",
        "Enter the group name": "Введите название группы",
        "Apply profile:": "Применить профиль:",
        "A new version is available": "Доступна новая версия",
        "Restart monitor immediately after update": "Перезапуск монитора сразу после обновления",
        "Restart when the monitor enters sleep mode": "Перезапуск монитора после перехода в спящий режим",
        "Restart monitor when it disconnected from all PCs": "Перезагрузить при отключении монитора и подключении всех ПК",
        "Enter the model name": "Введите название модели",
        "Create Update Task": "Создать задачу обновления",
        "Update Task List": "Обновить список задач",
        "Cancel All": "Отменить все",
        "View Details": "Подробнее",
        "Update Details": "Сведения об обновлении",
        "Update Mode": "Режим обновления",
        "Update Creation Time": "Время создания обновления",
        "Update Start Time": "Время начала обновления",
        "Are you sure you want to cancel all tasks?": "Вы действительно хотите отменить все задачи?",
        "Are you sure you want to cancel this task?": "Подтвердить отмену задания?",
        "Are you sure you want to delete the selected monitor?": "Вы действительно хотите удалить выбранный монитор?",
        "Confirm to delete all displays?": "确认要删除所有显示器吗？",
        "Are you sure you want to delete this？（Cannot delete when ungrouped）": "Действительно удалить? (Удаление невозможно, если элементы не сгруппированы)",
        "Tip: If an option in the display settings appears grayed out， it may be restricted by another setting。 Try adjusting other settings to remove the restriction。": "Совет. Если параметр в настройках дисплея отображается серым цветом, возможно, он ограничен другой настройкой. Попробуйте изменить другие параметры, чтобы снять ограничение.",
        "The WebSocket connection has been restored": "Соединение WebSocket восстановлено.",
        "The previous setting is currently being applied。 Please wait until the value changes before making any new settings。": "上一设置正在执行中，请等待数值变化后，再进行新的设置",
        "Please copy this password into the input box: ": "Скопируйте этот пароль в поле ввода: ",
        "Ebook": "Электронная книга",
        "largest": "крупнейший",
        "Max":"Макс",
        "Turn off auto mode": "Выключить автоматический режим",
        "Minimum": "Минимум",
        "Restore Factory Settings": "Восстановить заводские настройки",
        "Scenario Mode": "Режим сценария",
        "Color Gamut & Color Temperature": "Диапазон цветов и температура",
        "Panel Native": "Панель вкладок",
        "Close PIP, PBP":"Закрыть",
        "PIP window":"PIP",
        "PBP window":"PBP",
        "Neutral": "Нейтральный",
        "Neutral(7500K)":"Нейтральный",
        "Reddish(6500K)":"Теплый(6500K)",
        "Bluish(9300K)":"Холодный(9300K)",
        "Warm": "Теплый",
        "Cool": "Холодный",
        "Low Blue Light": "Снижение синего света",
        "Custom 1": "Настраиваемый 1",
        "Custom 2": "Настраиваемый 2",
        "Custom 3": "Настраиваемый 3",
        "BT.709": "BT.709",
        "BT.2020": "BT.2020",
        "Video Signal": "Сигнал изображения",
        "Game Mode": "Режим игры",
        "Off": "Выкл",
        "Game 1": "Игра 1",
        "Game 2": "Игра 2",
        "Response Time": "Время отклика",
        "Normal": "Нормальное",
        "Extreme": "Высокое",
        "Level 1": "Уровень 1",
        "Level 2": "Уровень 2",
        "Level 3": "Уровень 3",
        "Level 4": "Уровень 4",
        "Level 5": "Уровень 5",
        "Lan Indicator": "Индикатор LAN",
        "Linked": "Подключено",
        "No Link": "Соединение отсутствует",
        "Blinking": "Мигает",
        "Brightness": "Контрастность",
        "Contrast": "Яркость",
        "Smart Light": "Умный свет",
        "Volume Control": "Регулирование громкости",
        "USB Select": "Выбрать USB",
        "DP Select": "Выбрать DP",
        "Aspect Ratio": "Соотношение сторон",
        "Smart Traffic Light": "Smart Traffic Light",
        "daisy chain": "Последовательное подключение",
        "Dynamic Contrast": "Динамическая контрастность",
        "Smart Energy": "Smart Energy",
        "Smart Audio": "Smart Audio",
        "Distance Warning": "Предупреждение о расстоянии",
        "Ambient Light Detection": "Обнаружение окружающего света",
        "Enabled Ambient Light Detection": "Включить обнаружение окружающего света",
        "enabled":"enabled",
        "disabled":"disabled",
        "Waken on Touch": "Активация касанием",
        "True Split": "Разделение экрана",
        "Face Tracking": "Отслеживание лиц",
        "Audio Smart Switch": "Умный аудио-выключатель",
        "Auto-alarm": "Авто-оповещение",
        "KVM Switch": "Переключатель KVM",
        "KVM切换": "Переключатель KVM",
        "KVM(Keyboard, Video, Mouse) Switch enables two PCs to use one set of monitor, keyboard and mouse, Enable switching video, keyboard and mouse simultaneously. If disabled, only switch keyboard and mouse.": "Переключатель KVM (клавиатура, видео, мышь) позволяет двум ПК использовать один комплект монитора, клавиатуры и мыши, Включить одновременное переключение видео, клавиатуры и мыши. Если отключено, переключается только клавиатура и мышь",
        "Sitting Reminder": "Напоминание о сидячем положении",
        "Gaming": "Игровой процесс",
        "RGB Gain": "Цветовая настройка",
        "Serial No": "Серийный номер",
        "Firmware Version": "Версия прошивки",
        "Select response time level": "Выбрать уровень времени отклика",
        "Enable daisy chain": "Включить последовательное подключение",
        "Smart Traffic Light is a do not disturb light, helping to reduce distraction": "Технология Smart Traffic Light позволяет пользователю не отвлекаться на раздражители",
        "Enable/Disable the Audio Smart function": "Включить/Отключить функцию Умного аудио-выключателя",
        "Auto-alarm indicates whether the camera/MIC on monitor is in use": "Функция Авто-оповещения показывает, используется ли камера/микрофон на мониторе",
        "Enable Distance Warning": "Включить предупреждение о расстоянии",
        "Enable/disable face tracking": "Включить/Отключить функцию Отслеживание лиц",
        "Enable Sitting Reminder": "Включить напоминание о сидячем положении",
        "Smart Audio technology allows you to focus on the sound in front of you to improve voice clarity": "Технология Smart Audio позволяет сосредоточиться на звуке для улучшения четкости голоса",
        "Smart Energy technology automatically manages energy consumption by human detection sensor": "Технология Smart Energy автоматически подстраивается под освещенность помещения",
        "Implement PBP through only one cable": "Применяйте функцию PBP используя только один кабель",
        "Enable/Disable vPro technology in the monitor": "Включить/Отключить технологию vPro на мониторе",
        "Wake system by touch": "Разбудить систему касанием",
        "Set video source and USB source (used by keyboard and mouse) for every PC": "Установить источник видео и источник USB (используемый клавиатурой и мышью) для каждого ПК",
        "eKVM gives you instant access over two PC sources with a 2-button pressing of your mouse": "eKVM предоставляет вам мгновенный доступ к двум источникам сигнала ПК нажатием двух клавиш мыши",
        "Enable USB charging always on": "Включить постоянную USB зарядку",
        "Select DP version": "Выбор версии DP",
        "USB Charging": "Зарядка USB",
        "PC": "Компьютеры",
        "Double-click the CTRL": "Двойной клик CTRL",
        "Full Screen": "Полный экран",
        "Original AR": "Стандартное AR",
        "No scaling": "Без масштабирования",
        "on": "Открыть",
        "On": "Открыть",
        "Keyboard On": "Клавиатура включена",
        "Mouse On": "Мышь включена",
        "Image Creation": "Создание изображения",
        "Digital Cinema": "Цифровой кинотеатр",
        "Video Creation": "Создание видео",
        "Web Browsing": "Работа в веб-браузере",
        "Professional Image": "Профессиональное изображение",
        "DisplayPort": "DisplayPort",
        "Auto": "Авто",
        "Refresh": "Обновить",
        "Search": "Поиск",
        "Record": "Запись",
        "Username": "Имя пользователя",
        "Upload Time": "Время загрузки",
        "Add Profiles": "Добавить профили",
        "Latest Update Package": "Последний пакет обновления",
        "Upload Update Package": "Загрузить пакет обновления",
        "Upload": "Загрузить",
        "Size": "Размер",
        "Upload successful": "Загрузка успешно завершена",
        "Download successful": "Скачивание успешно завершено",
        "Refresh successful": "Обновление выполнено успешно",
        "The upgrade package does not match the device model": "Пакет обновления не совпадает с моделью",
        "Upgrade package does not match the device model":"Пакет обновления не соответствует модели устройства",
        "Please enter the setting name": "Введите имя настройки",
        "Edit": "Изменить",
        "Save": "Сохранить",
        "Delete": "Удалить",
        "Add": "Добавить",
        "Reset Password": "Сбросить пароль",
        "No": "№",
        "Full Name": "Полное имя",
        "Role": "Роль",
        "Creation Date": "Дата создания",
        "Operation": "Операция",
        "Actions": "Операция",
        "The user's initial password is ": "该用户的初始密码为 ",
        "The password has been reset to：": "Пароль сброшен на: ",
        "Invalid input。Usernames can only contain numbers and letters。": "Недопустимый ввод. Имя пользователя состоит из цифр и букв.",
        "Invalid input。The username must contain 4 to 30 characters。": "Недопустимый ввод. Имя пользователя должно содержать от 4 до 30 символов.",
        "Installation Package": "Установочный пакет",
        "Operation Date": "Дата операции",
        "Actions": "Действия",
        "Operator": "Оператор",
        "Paging component": "Paging component",
        "Quick page flipping": "Быстрое перевертание страницы",
        "Current page": "Current page",
        "Title": "Название",
        "Details": "Сведения",
        "This is the expanded area": "Это расширенная область",
        "Set Display Column": "Установить колонку отображения",
        "Upload file": "Загрузить файл",
        "Drop-down to expand": "Спадающее для расширения",
        "Default": "По умолчанию",
        "Default Info": "Информация по умолчанию",
        "Personal Center": "Персональный центр",
        "Personal center image button": "Персональная кнопка центра изображения",
        "Expandable area": "Расширяемая площадь",
        "Update Package Table": "Обновление таблицы пакетов",
        "This is the table header": "Это заголовок таблицы",
        "This is the table content": "Это содержимое таблицы",
        "UserList Table": "Таблица списка пользователей",
        "Page Up and Down": "Страница вверх и вниз",
        "Operation record table": "Таблица записей операций",
        "OSD upgrade details": "Детали обновления OSD",
        "Lenovo": "Lenovo",
        "Display Fleet Manager": "Display Fleet Manager",
        "HDR": "HDR",
        "eKVM": "eKVM",
        "Video": "Video",
        "Data": "Data",
        "vPro": "vPro",
        "Gama": "Gama",
        "PIP/PBP": "PIP/PBP",
        "OSD": "OSD",
        "USB-C Charging": "Зарядка через USB-C",
        "PIP": "PIP",
        "PBP": "PBP",
        /*
        "Simplified Chinese": "Упрощенный китайский",
        "English": "Английский язык",
        "Traditional Chinese": "Китайский стиль",
        "French": "Французский язык",
        "German": "Немецкий язык",
        "Italian": "Итальянский язык",
        "Spanish": "Испанский язык",
        "Japanese": "Японский язык",
        "Thai": "Тайский язык",
        "Ukrainian": "Украинский язык",
        "Russian": "Русский язык",
        */
        "Enter your account ID": "Введите идентификатор учетной записи",
        "Please Enter your account id":"Обратитесь к системному администратору для сброса пароля.",
        "Enter your password": "Введите пароль",
        "Cannot exceed 20 characters": "Длина не может превышать 20 символов",
        "Enter the original password": "Введите исходный пароль",
        "You have still selected the group that the device currently belongs to. If you want to move the device, please select another group. ": "Вы выбрали ту же группу, в которой уже находится устройство. Если вы хотите переместить устройство, выберите другую группу. ",
        "Enter the filename": "Введите имя файла",
        "Update Package Name": "Имя пакета обновления",
        "Select the date": "Выберите дату",
        "Select the time": "Выберите время",
        "Set the update mode": "Задайте режим обновления",
        "Restart when the monitor is not connected to any computer": "Перезапуск монитора, когда он не подключен ни к какому компьютеру",
     
        "Invalid file format": "Недопустимый формат файла. Поддерживаются только файлы zip/exe/dmg/app.",
        "Select a valid file type": "Выберите допустимый тип файла",
        "The data will be permanently deleted": "Данные будут безвозвратно удалены. Продолжить?",
        "The data is being processed。 Please do not submit again。": "Данные обрабатываются. Повторная отправка не требуется.",
        "Enter the profiles name": "Введите имя профиля",
        "Enter your username": "Введите имя пользователя",
        "Enter your full name": "Введите полное имя",
        "The initial password of this user is:": "Начальный пароль этого пользователя: ",
        "Select your role": "Выберите свою роль",
        "User Profile": "Профиль пользователя",
        "Downloading": "Скачивание...",
        "Enter the new password again。Two times of new password input is same": "Введите новый пароль еще раз.Новый пароль должен соответствовать ранее введенному.",
        "Request failed with status code 502": "Запрос не удался с кодом статуса 502",

        "Please Enter your x": "Введите {param}",
        "Select the x": "Выберите {param}",
        "Please select the correct file type x": "Выберите допустимый тип файла {param}",
        "Please select the correct file type": "Выберите допустимый тип файла",
        "Input characters within x characters": "Длина не может превышать {param} символов",

        "Monitor List":"Список мониторов",
        "List of update packages":"Список пакетов обновления",
        "Settings - Profiles":"Настройки - Профили",
        "User Management":"Управление пользователями",
      

        "Simplified Chinese": "简体中文",
        "English": "English",
        "Traditional Chinese": "繁體中文",
        "French": "Français",
        "German": "Deutsch",
        "Italian": "Italiano",
        "Spanish": "Español",
        "Japanese": "日本語",
        "Thai": "ภาษาไทย",
        "Ukrainian": "Українська",
        "Russian": "Русский язык",

        "System abnormality":"Системные аномалии",

        "Upgrade Package Record ID is empty":"Выберите пакет обновления",


        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。":"Неправильное время обновления. Это не может быть раньше текущего времени или более чем на 30 дней в будущем.",
      
        "Request parameter is invalid:The username must contain 4 to 30 characters。":"Параметр запроса недействителен:Имя пользователя должно содержать от 4 до 30 символов.",
        "The WebSocket connection has been lost Reconnecting":"Подключение WebSocket потеряно",
        "Request parameter is invalid：Usernames can only contain numbers and letters。":"Параметр запроса недействителен:Имя пользователя состоит из цифр и букв.",

        "Request parameter is invalid:Password length must be between 8-16 character":"Параметр запроса недействителен: длина пароля должна быть между 8-16 символами。",
        "The compiled package is missing: the component has a corresponding bin that has not been uploaded。Please upload it before compiling":"Скомпилированный пакет отсутствует: компонент имеет соответствующую корзину, которая не была загружена. Пожалуйста, загрузите его перед компиляцией.",

        "Request parameter is invalid：Password length must be 8–16 characters":"Параметр запроса недействителен:Длина пароля должна быть между 8-16 символами",


        "Illegal request header!": "Недопустимый заголовок запроса",
        "Invalid request parameters":"Неправильные параметры запроса",
        "Export": "Экспорт",
        "It is already a high-version and there is no need to upgrade":"Это уже высокая версия и нет необходимости в обновлении",
        "Repeated request， please try again later":"Repeated request, please try again later",
        "Communication":"коммуникация‌"
    }
}